import Vue from 'vue';
import Vuex from 'vuex';

import { authStore } from '../modules/auth/store';
import { usersStore } from '../modules/user-accounts/store';
import { searchRequestsStore } from '../modules/search-requests/store';
import { reportsStore } from '../modules/reports/store';
import { productPricesStore } from '../modules/product-prices/store';
import { sitesStore } from '../modules/sites/store';
import { financialStore } from '../modules/financials/store';
import { notificationsStore } from '../modules/notifications/store';
import { accountingStore } from '../modules/accounting/store';
import { pagesRolesSettingStore } from '../modules/pages-roles-setting/store';
import { permittingStore } from '../modules/permitting/store';
import { settingsStore } from '../modules/settings/store';
import { formsStore } from '../modules/forms/store';
import { outageStore } from '../modules/outage/store';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    applicationName: 'eServices',
    isAppRecaptchaVerified: false,
  },
  getters: {
    appName(state) {
      return state.applicationName;
    },
    isRecaptchaVerified(state) {
      return state.isAppRecaptchaVerified;
    },
  },
  mutations: {
    setRecaptchaVerifiedFlag(state, val) {
      state.isAppRecaptchaVerified = val;
    },
  },
  modules: {
    auth: { ...authStore },
    users: { ...usersStore },
    searchRequests: { ...searchRequestsStore },
    reports: { ...reportsStore },
    productPrices: { ...productPricesStore },
    sites: { ...sitesStore },
    financials: { ...financialStore },
    notifications: { ...notificationsStore },
    accounting: { ...accountingStore },
    pagesRolesSetting: { ...pagesRolesSettingStore },
    permitting: { ...permittingStore },
    settings: { ...settingsStore },
    forms: { ...formsStore },
    outage: { ...outageStore },
  },
});
